/* tslint:disable */
/* eslint-disable */
/**
 * My REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: jason.tai@octopus-tech.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MemberActionLogDto,
    MemberActionLogDtoFromJSON,
    MemberActionLogDtoFromJSONTyped,
    MemberActionLogDtoToJSON,
} from './MemberActionLogDto';

/**
 * 
 * @export
 * @interface PagingModelMemberActionLogDto
 */
export interface PagingModelMemberActionLogDto {
    /**
     * 
     * @type {Array<MemberActionLogDto>}
     * @memberof PagingModelMemberActionLogDto
     */
    list?: Array<MemberActionLogDto>;
    /**
     * 
     * @type {number}
     * @memberof PagingModelMemberActionLogDto
     */
    numPerPage?: number;
    /**
     * 
     * @type {number}
     * @memberof PagingModelMemberActionLogDto
     */
    pageno?: number;
    /**
     * 
     * @type {number}
     * @memberof PagingModelMemberActionLogDto
     */
    pagenum?: number;
}

export function PagingModelMemberActionLogDtoFromJSON(json: any): PagingModelMemberActionLogDto {
    return PagingModelMemberActionLogDtoFromJSONTyped(json, false);
}

export function PagingModelMemberActionLogDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagingModelMemberActionLogDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': !exists(json, 'list') ? undefined : ((json['list'] as Array<any>).map(MemberActionLogDtoFromJSON)),
        'numPerPage': !exists(json, 'numPerPage') ? undefined : json['numPerPage'],
        'pageno': !exists(json, 'pageno') ? undefined : json['pageno'],
        'pagenum': !exists(json, 'pagenum') ? undefined : json['pagenum'],
    };
}

export function PagingModelMemberActionLogDtoToJSON(value?: PagingModelMemberActionLogDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': value.list === undefined ? undefined : ((value.list as Array<any>).map(MemberActionLogDtoToJSON)),
        'numPerPage': value.numPerPage,
        'pageno': value.pageno,
        'pagenum': value.pagenum,
    };
}

